import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex gap-4" }
const _hoisted_2 = { key: 0 }

import { ref, computed } from "vue";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import SupportService from "../services/SupportService";
import { ElNotification } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  __name: 'TranslateText',
  props: {
    text: {},
    case: {}
  },
  emits: ["translated"],
  setup(__props: any, { emit }) {

const props = __props;


const isLoading = ref(false);
const toggle = ref(false);
const translatedText = ref({
  content: "",
  language: "",
});
const id = computed(() => props.case.id);
// const content = computed(() => props.text);
const formData = ref<any>({
  targetLanguage: "English",
});

const translate = async (language: any) => {
  isLoading.value = true;
  try {
    formData.value.targetLanguage = language.englishName;
    const res = await SupportService.translateCaseText(
      id.value,
      formData.value
    );
    translatedText.value.content = res;
    translatedText.value.language = language.name;
    ElNotification({
      title: language.name,
      message: "Translation successful",
      type: "success",
    });
    emit("translated");
  } catch (e) {
    ElNotification({
      title: language.name,
      message: "Translation failed",
      type: "error",
    });
    console.log(e);
  }
  isLoading.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      color: "#626aef",
      dark: true,
      size: "small",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle.value = !toggle.value))
    }, {
      default: _withCtx(() => [
        _createTextVNode("Translate")
      ]),
      _: 1
    }),
    (toggle.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LanguageTypes).all, (item) => {
            return (_openBlock(), _createBlock(_component_el_button, {
              key: item.code,
              size: "small",
              onClick: ($event: any) => (translate(item)),
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["onClick", "disabled"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})